export default __webpack_public_path__ + "static/media/center-img-mobile.aeabd9aa.jpg";